/* eslint-disable jsx-a11y/no-static-element-interactions */
import Button from '@/components/Button';
import React from 'react';
import { AnswerProps } from '../useDailyAnswer';

export const StartQuestions = ({
  startQuestions,
  onboardingQuestionDescription,
  onboardingQuestionButtonLabel,
}: {
  selectedAnswer: AnswerProps[];
  startQuestions: React.Dispatch<boolean>;
  onboardingQuestionTitle?: string | null;
  onboardingQuestionDescription?: string | null;
  onboardingQuestionButtonLabel?: string | null;
}) => {
  return (
    <div className="min-h-[173px] w-[366px] rounded-2xl border border-[#A1C3EC] bg-white p-sh-30 md:w-[415px]">
      <div className="flex min-h-[100px] items-center justify-center">
        <p className="grow text-sh-14-18">{onboardingQuestionDescription}</p>
      </div>
      <div className="flex gap-sh-15">
        <Button theme={'solid'} className=" mt-sh-30" onClick={() => startQuestions(true)}>
          {onboardingQuestionButtonLabel || 'Start'}
        </Button>
      </div>
    </div>
  );
};
